import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'

import Properties from '../components/Properties'
import Residents from '../components/Residents'

import Details from '../components/Details'

import PropertyRoutes from './PropertyRoutes'

import PushNotifications from '../components/PushNotifications'
import AddPush from '../components/PushNotifications/AddPush'
import EditPush from '../components/PushNotifications/EditPush'

import Chat from '../components/Chat'
import ChatApp from '../components/Chat/ChatApp'

const OwnerRoutes = ({ location }) => {
  return (
    <Switch location={location}>
      <Route key="properties" exact path="/" component={Properties} />
      <Route key="properties" exact path="/properties" component={Properties} />
      <Route key="property" path="/properties/:id" component={PropertyRoutes} />

      <Route key="residents" exact path="/residents" component={Residents} />
      <Route key="add" path="/:category(owners|residents)/add" exact render={ () => null } />

      <Route key="detail" path="/:category(owners|residents)/:id" exact component={Details} />

      <Route key="push" exact path="/push" component={PushNotifications} />
      <Route key="add_push" exact path="/push/add" component={AddPush} />
      <Route key="add_custom_push" exact path="/push/add/:category(owner|property|resident)/:id" component={AddPush} />
      <Route key="edit_push" exact path="/push/edit/:id" component={EditPush} />

      <Route key="chat" exact path="/chat" component={Chat} />
      <Route key="chat_room" exact path="/chat/:category(owner|property|resident)/:id" component={Chat} />
      <Route key="chat_room" exact path="/chat/room/:id" component={ChatApp} />
    </Switch>

  )
}

export default withRouter(OwnerRoutes)



// WEBPACK FOOTER //
// ./src/routes/OwnerRoutes.jsx